const styles = {
  planGridItem: { display: "flex", flexDirection: "column" },
  singlePlanContainer: { maxWidth: 520 },
  rolloverSteps: { mt: 4, px: 1 },
  rolloverStepsTitle: { fontWeight: 700, mb: 2, textAlign: "center" },
  rolloverStepCard: {
    backgroundColor: "#f0fdf4",
    borderRadius: 3,
    p: 2,
    height: "100%",
  },
  rolloverStepNumber: {
    fontWeight: 800,
    fontSize: 22,
    color: "#16a34a",
    mb: 0.5,
  },
  rolloverStepTitle: { fontWeight: 700, fontSize: 14, mb: 0.5 },
  rolloverStepDesc: { fontSize: 13, color: "text.secondary" },
};

export default styles;
